import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Renderer, ViewChild, ElementRef, Directive, Input, Inject, TemplateRef } from '@angular/core';
//import { ROUTES } from '../sidebar/sidebar.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { SweetMessage } from '../../config/sweet-message';
import { SessionService } from '../../services/session.service';
import { dashboard_url } from '../../config/master-dashboard';
import { SYSVERSION } from '../../config/app.config';
import { ParametroService } from '../../services/parametro.service';
import { CbtContadorService } from '../../services/cbt-contador.service';
import { EmpresaService } from '../../services/empresa.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

var misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
}
declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html',
    providers: [SessionService, ParametroService, EmpresaService]
})

export class NavbarComponent implements OnInit {
    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton;
    private sidebarVisible: boolean;
    public currentTitle: String = "";
    public nombre_empresa: String;
    public msgSweet: SweetMessage;
    public Mod_FactElec: string;
    public cbts_pendientes: String;
    public bsModalRef: BsModalRef;

    @Input() tactilLayaut: boolean;
    public elem: any;
    public fullscrean: boolean = false;
    public link_guia: any;
    public link_whatsapp: any;

    public usuario: any = {
        usuario: "",
        persona: {
            nombres: "",
            apellido_paterno: "",
            apellido_materno: "",
        },
        perfil: {
            nombre: ""
        }
    };

    @ViewChild("navbar-cmp") button;
    public empresa_id: String;
    public is_adeuda_valores: String;


    constructor(
        location: Location,
        private renderer: Renderer,
        private element: ElementRef,
        protected localStorage: AsyncLocalStorage,
        private ss: SessionService,
        private NavRoute: Router,
        private parametroService: ParametroService,
        public cbtContadorService: CbtContadorService,
        private empresaService: EmpresaService,
        @Inject(DOCUMENT) private document: any,
        public modalService: BsModalService
    ) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
        this.msgSweet = new SweetMessage();

        this.usuario.nombres = this.ss.getData('nombres');
        this.usuario.apellidos = this.ss.getData('apellidos');
        this.usuario.usuario = this.ss.getData('usuario');
        this.usuario.perfil = this.ss.getData('perfil');
        this.usuario.sucursal = this.ss.getData('sucursal');

        this.Mod_FactElec = this.ss.getData("mod_felectronica");

        this.localStorage.getItem('menuItems').subscribe(data => {
            this.listTitles = data;
        });

        this.nombre_empresa = this.ss.getData('empresa');
        this.cbts_pendientes = "";
        this.empresa_id = this.ss.getData('empresa_id');
        //this.localStorage.getItem('currentTitle').subscribe(data => this.currentTitle = data);
        this.bsModalRef = new BsModalRef();
        this.link_guia = {};
        this.link_whatsapp = {};
    }

    ngOnInit() {
        this.elem = document.documentElement;

        /*this.localStorage.getItem('menuItems').subscribe(
            res => {
                //this.location.prepareExternalUrl(this.location.path());
            }
        );*/


        //this.listTitles = ROUTES.filter(listTitle => listTitle);

        this.getEmpresaById();

        var navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];

        if (this.Mod_FactElec) {
            this.cbtContadorService.getContador$().subscribe(
                res => this.cbts_pendientes = res.toString()
            );

            this.cbtContadorService.actualizarContador();
        }

        this.getLinkGuia(29);
        this.getLinkWhatsapp(30);


    }

    /*loadNavbar(){
        var navbar : HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        if($('body').hasClass('sidebar-mini')){
            misc.sidebar_mini_active = true;
        }
        $('body #minimizeSidebar').click(function(){
            var $btn = $(this);

            if(misc.sidebar_mini_active == true){
                $('body').removeClass('sidebar-mini');
                misc.sidebar_mini_active = false;

            }else{
                setTimeout(function(){
                    $('body').addClass('sidebar-mini');

                    misc.sidebar_mini_active = true;
                },300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            var simulateWindowResize = setInterval(function(){
                window.dispatchEvent(new Event('resize'));
            },180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function(){
                clearInterval(simulateWindowResize);
            },1000);
        });
    }*/

    openFullscreen() {
        if (this.elem.requestFullscreen) {
            this.elem.requestFullscreen();
        } else if (this.elem.mozRequestFullScreen) {
            /* Firefox */
            this.elem.mozRequestFullScreen();
        } else if (this.elem.webkitRequestFullscreen) {
            /* Chrome, Safari and Opera */
            this.elem.webkitRequestFullscreen();
        } else if (this.elem.msRequestFullscreen) {
            /* IE/Edge */
            this.elem.msRequestFullscreen();
        }
        this.fullscrean = this.fullscrean = true;
    }

    closeFullscreen() {
        if (this.document.exitFullscreen) {
            this.document.exitFullscreen();
        } else if (this.document.mozCancelFullScreen) {
            /* Firefox */
            this.document.mozCancelFullScreen();
        } else if (this.document.webkitExitFullscreen) {
            /* Chrome, Safari and Opera */
            this.document.webkitExitFullscreen();
        } else if (this.document.msExitFullscreen) {
            /* IE/Edge */
            this.document.msExitFullscreen();
        }
        this.fullscrean = this.fullscrean = false;
    }

    getEmpresaById() {
        this.empresaService.getById(this.empresa_id).subscribe(
            res => {
                this.is_adeuda_valores = res.is_adeuda_valores;
                /*if(res.is_adeuda_valores == "1"){
                    this.isAdeudaValores(res);
                }*/
            }
        );
    }

    isMobileMenu() {
        if ($(window).width() < 991) {
            return false;
        }
        return true;
    }

    sidebarOpen() {
        var toggleButton = this.toggleButton;
        var body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');
        this.sidebarVisible = true;
    }
    sidebarClose() {
        var body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
    }
    sidebarToggle() {
        // var toggleButton = this.toggleButton;
        // var body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible == false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    getTitle() {
        if (!this.listTitles) {
            return;
        }
        var titlee = this.location.prepareExternalUrl(this.location.path());

        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(2);
        }

        for (var item = 0; item < this.listTitles.length; item++) {
            var parent = this.listTitles[item];
            if (parent.path === titlee) {
                return this.currentTitle = parent.nombre;
            } else if (parent.children) {
                //var children_from_url = titlee.split("/")[2];
                var children_from_url = titlee;

                for (var current = 0; current < parent.children.length; current++) {
                    if (parent.children[current].path === children_from_url) {
                        return this.currentTitle = parent.children[current].nombre;
                    }
                }
            }
        }
        //return 'Dashboard';

        //this.localStorage.setItem('currentTitle', this.currentTitle).subscribe();
        return this.currentTitle;
    }

    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }

    logout() {
        this.msgSweet.showMessage('delete-confirm-message', "¿Desea cerrar su sesión actual?").then(
            res => {
                if (this.is_adeuda_valores == "1") {
                    this.isAdeudaValores({ nombre_comercial: this.nombre_empresa });
                }

                this.ss.deleteData().then(() => this.NavRoute.navigate(['login']));
            }
        );
    }

    clickIcon() {
        if (this.tactilLayaut) {
            this.NavRoute.navigate(['/menu']);
        } else {
            var navbar: HTMLElement = this.element.nativeElement;
            this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
            if ($('body').hasClass('sidebar-mini')) {
                misc.sidebar_mini_active = true;
            }
            // $('body #minimizeSidebar').click(function(){
            var $btn = $(this);

            if (misc.sidebar_mini_active == true) {
                $('body').removeClass('sidebar-mini');
                misc.sidebar_mini_active = false;

            } else {
                setTimeout(function () {
                    $('body').addClass('sidebar-mini');

                    misc.sidebar_mini_active = true;
                }, 300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            var simulateWindowResize = setInterval(function () {
                window.dispatchEvent(new Event('resize'));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function () {
                clearInterval(simulateWindowResize);
            }, 1000);
            // });
        }
    }

    changeMode() {
        localStorage.removeItem('tactilLayaut');
        localStorage.setItem('tactilLayaut', (!this.tactilLayaut).toString());

        location.reload();
    }

    onAboutUs() {
        let msn = "";
        msn += "<p><b style='font-size:24px;'>Dinami</b></p>";
        msn += "<p>Desarrollado por Nextcode S.A</p>";
        msn += "<p>Todos los derechos reservados</p>";
        msn += "<p>Version: " + SYSVERSION + "</p>";

        this.msgSweet.showMessage('single-message', msn);
    }

    isAdeudaValores(empresa: any) {
        let msn = "";
        msn += "<div style='text-align: left !important;'>";
        msn += "<p style='text-align: center; color: rgb(202, 44, 44);'><i class='fa fa-exclamation-triangle'></i><b style='font-size:24px;'>Mensaje de Dinami</b></p>";
        msn += "<p>Estimado <b>" + empresa.nombre_comercial + "</b>, no hemos recibido el pago correspondiente <b>:(</b></p>";
        msn += "<p>Recuerde que puede realizar el pago a las siguientes cuentas: </p>";
        msn += "<p>Bco. Pichincha Cta. Cte. <b>#2100119866</b> <br>";
        msn += "Bco. Pacífico Cta. Cte. <b>#7929137</b> </p>";
        msn += "<p>A nombre de <b>Nextcode S.A.</b> y enviar el comprobante al correo <b>lchoez@nextcode.ec</b> o al WhatsApp <b>0961178934</b></p>";
        msn += "<p>Saludos.</p>";
        msn += "</div>";

        this.msgSweet.showMessage('single-message', msn);
    }

    add(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template, Object.assign({}, { class: 'modal-xs' }));
    }

    getLinkGuia(id) {
        this.parametroService.getById(id).subscribe(
            res => {
                this.link_guia = res.valor;
            },
            err => {
                this.link_guia = {};
            }
        );
    }

    getLinkWhatsapp(id) {
        this.parametroService.getById(id).subscribe(
            res => {
                this.link_whatsapp = res.valor;
            },
            err => {
                this.link_whatsapp = {};
            }
        );
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/layouts/navbar/navbar.component.ts